import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "content"]

  connect() {
    this.tooltipElement = null
    this._handleReposition = this.positionTooltip.bind(this)
  }

  disconnect() {
    this.hide()
  }

  show() {
    if (this.tooltipElement) return

    this.tooltipElement = document.createElement("div")
    this.tooltipElement.className = "fixed z-[200] w-48 rounded-lg border border-[#374151] bg-[#1a1a1a] p-2.5 text-[10px] shadow-xl pointer-events-none"
    this.tooltipElement.innerHTML = this.contentTarget.innerHTML
    document.body.appendChild(this.tooltipElement)

    this.positionTooltip()
    window.addEventListener("scroll", this._handleReposition, true)
    window.addEventListener("resize", this._handleReposition)
  }

  hide() {
    if (!this.tooltipElement) return

    window.removeEventListener("scroll", this._handleReposition, true)
    window.removeEventListener("resize", this._handleReposition)
    this.tooltipElement.remove()
    this.tooltipElement = null
  }

  positionTooltip() {
    if (!this.tooltipElement) return

    const triggerRect = this.triggerTarget.getBoundingClientRect()
    const tooltipRect = this.tooltipElement.getBoundingClientRect()
    const spacing = 8
    const viewportPadding = 12

    let top = triggerRect.top - tooltipRect.height - spacing
    if (top < viewportPadding) {
      top = Math.min(triggerRect.bottom + spacing, window.innerHeight - tooltipRect.height - viewportPadding)
    }

    let left = triggerRect.left
    if (left + tooltipRect.width > window.innerWidth - viewportPadding) {
      left = window.innerWidth - tooltipRect.width - viewportPadding
    }
    left = Math.max(left, viewportPadding)

    this.tooltipElement.style.top = `${top}px`
    this.tooltipElement.style.left = `${left}px`
  }
}
